import { FIELD_STATISTICS_EXATREK_COLUMNS } from '../FieldStatisticsColumns';
import moment from 'moment/moment';
import { Box, Typography } from '@mui/material';
import Styles from '../FieldStatisticsContainer.module.less';
import React, { memo } from 'react';
import PropTypes from 'prop-types';
import EmptyColumnCell from './EmptyColumnCell';
import StandardColumnCell from './StandardColumnCell';

const ClaasColumnCell = ({ column, stats }) => {
  switch (column) {
    case FIELD_STATISTICS_EXATREK_COLUMNS.HARVEST_DATE_EXATREK:
      return stats.harvest ? (
        <StandardColumnCell
          primary={moment(stats.harvest).format('MMMM DD')}
          secondary={moment(stats.harvest).format('YYYY')}
        />
      ) : (
        <EmptyColumnCell />
      );
    case FIELD_STATISTICS_EXATREK_COLUMNS.YIELD_AVERAGE_EXATREK:
      if (stats.averageYield) {
        let lhsPercentage = 0;
        let rhsPercentage = 0;
        if (stats.yieldNormalized > 0.5) {
          lhsPercentage = 0;
          rhsPercentage = (stats.yieldNormalized - 0.5) * 200;
        } else if (stats.yieldNormalized < 0.5) {
          lhsPercentage = (0.5 - stats.yieldNormalized) * 200;
          rhsPercentage = 0;
        }
        return (
          <Box
            sx={{
              width: '100%',
            }}
          >
            <Box
              className={Styles.absolute}
              style={{ padding: '8px 0' }}
              sx={{
                display: 'flex',
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  width: '100%',
                  height: '100%',
                  justifyContent: 'center',
                }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    flex: 49,
                    height: '100%',
                    justifyContent: 'flex-end',
                  }}
                >
                  <Box
                    sx={{
                      width: `${lhsPercentage}%`,
                      height: '100%',
                      bgcolor: '#CE1A3C4C',
                    }}
                  />
                </Box>
                <Box
                  sx={{
                    display: 'flex',
                    flex: 2,
                    bgcolor: '#4140421A',
                    height: '100%',
                  }}
                />
                <Box
                  sx={{
                    display: 'flex',
                    flex: 49,
                    height: '100%',
                  }}
                >
                  <Box
                    sx={{
                      width: `${rhsPercentage}%`,
                      height: '100%',
                      bgcolor: '#78A22F80',
                    }}
                  />
                </Box>
              </Box>
            </Box>
            <Box
              className={Styles.absolute}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
              }}
            >
              <Typography className={Styles.title}>
                {stats.averageYield.toFixed(1) + ' t/ha'}
              </Typography>
            </Box>
          </Box>
        );
      } else {
        return <EmptyColumnCell />;
      }
    case FIELD_STATISTICS_EXATREK_COLUMNS.CROP_MOISTURE_EXATREK:
      return stats.averageMoisture ? (
        <StandardColumnCell primary={`${Number(stats.averageMoisture.toFixed(1))} %`} />
      ) : (
        <EmptyColumnCell />
      );
    case FIELD_STATISTICS_EXATREK_COLUMNS.YIELD_TOTAL_EXATREK:
      return stats.totalYield ? (
        <StandardColumnCell primary={`${Number(stats.totalYield.toFixed(1))} t`} />
      ) : (
        <EmptyColumnCell />
      );
    case FIELD_STATISTICS_EXATREK_COLUMNS.FUEL_CONSUMPTION_EXATREK:
      return stats.averageFuel ? (
        <StandardColumnCell primary={`${Number(stats.averageFuel.toFixed(1))} L/ha`} />
      ) : (
        <EmptyColumnCell />
      );
    default:
      return <EmptyColumnCell />;
  }
};

ClaasColumnCell.propTypes = {
  column: PropTypes.string,
  stats: PropTypes.object,
};

export default memo(ClaasColumnCell);
